import React from 'react'
import classnames from 'utils/classnames'

const Card = ({ children, fluid = false, className, ...rest }) => {
    const classNames = classnames(
        'shadow-md border border-black', 
        className, 
        { 
            'w-full': fluid,
            'w-fit': !fluid
        } 
    );
    
    return (
        <div className={classNames} {...rest}>
            { children }
        </div>
    )
}

export default Card